import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class OringRecommendationStep2Service {
  private grooveRecommendationStep2;
  private grooveRecommendationJisStep2;
  constructor(private http: HttpClient) {}

  private getGrooveRecommendationStep2() {
    this.grooveRecommendationStep2 = this.http.get('assets/calculations-json/OringRecommendationStep2.json');
  }

  private getGrooveRecommendationJisStep2() {
    this.grooveRecommendationJisStep2 = this.http.get('assets/calculations-json/OringRecommendationStep2_jis.json');
  }

  getGrooveRecommendation() {
    if (!this.grooveRecommendationStep2) {
      this.getGrooveRecommendationStep2();
    }
    return this.grooveRecommendationStep2;
  }

  getGrooveRecommendationJis() {
    if (!this.grooveRecommendationJisStep2) {
      this.getGrooveRecommendationJisStep2();
    }
    return this.grooveRecommendationJisStep2;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/OringRecommendationStep2Service.ts